const SvgProfileCheckIcon = ({ stroke = '#FF692E' }) => {
  return (
    <>
      <svg
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.66679 9.33333H4.66679C3.73641 9.33333 3.27123 9.33333 2.89269 9.44816C2.04043 9.70669 1.37348 10.3736 1.11495 11.2259C1.00012 11.6044 1.00012 12.0696 1.00012 13M10.3335 11L11.6668 12.3333L14.3335 9.66667M9.33346 4C9.33346 5.65685 7.99031 7 6.33346 7C4.6766 7 3.33346 5.65685 3.33346 4C3.33346 2.34315 4.6766 1 6.33346 1C7.99031 1 9.33346 2.34315 9.33346 4Z"
          stroke={stroke}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  )
}

export default SvgProfileCheckIcon
